(function () {
  'use strict';

  angular.module('app').component('discountCouponList', discountCouponList());

  function discountCouponList() {
    return {
      bindings: {},
      controller: DiscountCouponListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/discount-coupons/discount-coupon-list/discount-coupon-list.component.html',
    };
  }

  DiscountCouponListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'moment',
    '$location',
    'DiscountCouponService',
  ];

  function DiscountCouponListComponent(
    config,
    UtilService,
    AbilityService,
    moment,
    $location,
    DiscountCouponService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_discountcoupon_accountadmin'),
      canShow: AbilityService.can('show_discountcoupon_accountadmin'),
      canUpdate: AbilityService.can('update_discountcoupon_accountadmin'),
      canDestroy: AbilityService.can('destroy_discountcoupon_accountadmin'),
    };

    vm.discountCouponTypes = config.COMPUTATION_TYPES;
    vm.discountCouponStatuses = config.STATUS;

    vm.filterCriteria = DiscountCouponService.getFilterCriteria();

    // private properties
    // -----------------------
    const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      vm.fetchResult();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingDiscountCoupons = true;
      DiscountCouponService.getDiscountCoupons(vm.filterCriteria).then(function (data) {
        vm.discountCoupons = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        setDiscountCoupons(vm.discountCoupons);

        vm.loadingDiscountCoupons = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.clearSearch = function () {
      vm.filterCriteria = DiscountCouponService.getFilterCriteria();
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.createDiscountCoupon = function () {
      if (!vm.permissions.canCreate) return;

      $location.path('/discount_coupons/new');
    };

    vm.showDiscountCoupon = function (item, mode) {
      if (!vm.permissions.canShow) return;

      $location.path(`/discount_coupons/${item.id}`).search({ mode: mode });
    };

    vm.changeDiscountCouponStatus = function (item) {
      if (!vm.permissions.canUpdate) return;

      DiscountCouponService.changeDiscountCouponStatus(item);
    };

    vm.deleteDiscountCoupon = function (item) {
      if (!vm.permissions.canDestroy) return;

      DiscountCouponService.deleteDiscountCoupon(item.id, vm.fetchResult);
    };

    // private methods
    // -----------------------

    function setDiscountCoupons(discountCoupons) {
      discountCoupons.forEach(function (discount_coupon) {
        discount_coupon.from = moment(discount_coupon.from).format(dateDisplay);
        discount_coupon.to = moment(discount_coupon.to).format(dateDisplay);
      });
    }
  }
})();
